import React from "react";
import { PageLayout, PageContent, PageHeader, PageLoading, Skeleton, Badge } from "../../ui";
import { useDocuments } from "./hooks/useDocuments";
import { DocumentsView } from "./components/DocumentsView";
import { DOCS_LINK } from "../../lib/constants";

const CONTEXT_DOCS_URL = `${DOCS_LINK}/documentation/getting-started/context`;
const PAGE_DESCRIPTION =
  "Upload reference documents and example evaluations to ground your evaluations.";
// Context only works with the align-20260109 model, which is itself in Beta.
const BETA_BADGE = <Badge variant="warning">Beta</Badge>;

export default function DocumentsPage() {
  const {
    documents,
    isLoading,
    isUploading,
    isUploadingAnnotations,
    isSyncing,
    deleteProgress,
    error,
    lastUploadResult,
    onUpload,
    onUploadAnnotations,
    onSync,
    onDelete,
    clearUploadResult,
  } = useDocuments();

  if (isLoading) {
    return (
      <PageLoading
        title="Context"
        description={PAGE_DESCRIPTION}
        badge={BETA_BADGE}
        maxWidth="5xl"
      >
        <div className="space-y-6">
          <Skeleton height={140} className="rounded-lg" />
          <Skeleton height={140} className="rounded-lg" />
          <Skeleton height={220} className="rounded-lg" />
        </div>
      </PageLoading>
    );
  }

  return (
    <PageLayout>
      <PageContent maxWidth="5xl">
        <PageHeader
          title="Context"
          badge={BETA_BADGE}
          description={
            <>
              {PAGE_DESCRIPTION}{" "}
              <a
                href={CONTEXT_DOCS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary !no-underline hover:underline"
              >
                Learn more ↗
              </a>
            </>
          }
        />
        {error && (
          <div className="rounded-md border border-destructive/30 bg-destructive/10 px-3 py-2 text-sm text-destructive mb-6">
            <span>{error}</span>
          </div>
        )}
        <DocumentsView
          documents={documents}
          isUploading={isUploading}
          isUploadingAnnotations={isUploadingAnnotations}
          isSyncing={isSyncing}
          deleteProgress={deleteProgress}
          lastUploadResult={lastUploadResult}
          onUpload={onUpload}
          onUploadAnnotations={onUploadAnnotations}
          onSync={onSync}
          onDelete={onDelete}
          onClearUploadResult={clearUploadResult}
        />
      </PageContent>
    </PageLayout>
  );
}
